import deliveryFoodStyles from "../../DeliveryFood.module.css";

export const DeliveryFoodSectionHeader = ({ name, index }: any) => {
    return (
        <div key={`delivery-section-${name}-${index}`} className={deliveryFoodStyles.SectionHeader}>
            {name}
        </div>
    );
};
